export const config = {
    ekuriaServerUrl: `${process.env.REACT_APP_EKURIA_SERVER}`,
}
